export function formatURL(urlVar) {
        if (urlVar){
            let addr = new URL(urlVar)
            return addr.hostname
        }

    
    }